import { v4 as uuidv4 } from 'uuid';
import {
  ENQUEUE_SNACKBAR,
  REMOVE_SNACKBAR,
  ENQUEUE_BANNER,
  REMOVE_BANNER,
  ACTIVATE_BANNER,
  SET_FREE_CREDIT_AWARE,
  CLEAR_BANNER_STATE,
} from '../actions';

/**
 * Add an error to the error array.
 */
export const enqueueSnackbar = (notification) => (dispatch) =>
  dispatch({
    type: ENQUEUE_SNACKBAR,
    notification: {
      key: uuidv4(),
      ...notification,
    },
  });

/**
 * Remove an error from the error array.
 */
export const removeSnackbar = (key) => (dispatch) =>
  dispatch({
    type: REMOVE_SNACKBAR,
    key,
  });

/**
 * Add a message to the message array.
 */
export const enqueueBanner = (notification) => (dispatch) =>
  dispatch({
    type: ENQUEUE_BANNER,
    notification: {
      ...notification,
    },
  });
/**
 * Remove a message from the message array.
 */
export const removeBanner = () => (dispatch) =>
  dispatch({
    type: REMOVE_BANNER,
  });

/**
 * Activate the first message from the message array.
 */
export const activateBanner = () => (dispatch) =>
  dispatch({
    type: ACTIVATE_BANNER,
  });

/**
 * Activate the first message from the message array.
 */
export const setFreeCreditAware = () => (dispatch) =>
  dispatch({
    type: SET_FREE_CREDIT_AWARE,
  });

export const setClearBannerState = () => (dispatch) =>
  dispatch({
    type: CLEAR_BANNER_STATE,
  });
